export default "__VITE_ASSET__DeThrqqL__"